/** @module Specification/CareAndComposition/CareIconPerLanguageRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/RefImage",
	"./CareSymbolPerLanguageRendererMixin",
	"./CareIconPerLanguageRendererMixin"
], function(declare,RefImage,CareSymbolPerLanguageRendererMixin,CareIconPerLanguageRendererMixin) {

	return declare([RefImage,CareSymbolPerLanguageRendererMixin,CareIconPerLanguageRendererMixin], {

	});
});
